<template>
  <div class="cd-select-wrapper" :style="{width:width+'px'}">
    <div class="select-top" :class="{topShadow:isShow,disabled:disabled}" @click="toggleSelectOption">
      <span class="left-wrapper" ><input type='text' :value='currentValue'
                                                              :style="{width:width+'px'}" readonly/>
        <span>{{idx> -1 ?  currentOption[idx][headLabelKey?valueKey:labelKey] : placeholder}}</span>
      </span>
      <i class='toDown-icon'>
        <!-- <img :src='icon.todown'> -->
      </i>
    </div>
    <transition name="slide-fade">
      <div v-if='isShow' class="select-list trans_fade_image" :class="{trans:isShow}" >
        <div class="search" v-if="isSearch" @click.stop="isShow=true">
          <input type="text" @focus.prevent="isShow=true" v-model="searchText">
        </div>
        <div v-show="item&&item[labelKey]&&item[labelKey].includes(searchText)" v-for="(item,index) in options"
             class="cd-select-item" :key="index"
             :class="{checked:currentValue == (valueKey ? item[valueKey] : item.value)}"
             @click="selectOption(item,index)" @mousedown.prevent.stop>
          <span class="option-wrapper" :title="labelKey ? item[labelKey] : item.label"
                :class="{active:(valueKey ? item[valueKey] : item.value) == value}">{{labelKey ? item[labelKey] : item.label}} </span>
        </div>
      </div>
    </transition>
  </div>

</template>

<script>
  import Emitter from './../emitter';
  export default {
    name: "Select"
    , componentName: 'Select'
    , mixins: [Emitter]
    , props: {
      title: {
        type: String
        , default: ''
      }
      , value: [String, Number, Object, Boolean]
      , options: {
        type: Array
        , default() {
          return [];
        }
      }
      , isSearch: {
        type: Boolean
        , default: false
      }
      , width: {
        type: Number
        , default: 110
      }
      // ,isneed:{
      //   type: Boolean
      //   ,default: true
      // }
      , disabled: {
        type: Boolean
        , default: false
      }
      , valueKey: {
        type: String,
        default: 'value'
      }  // 作为 value 唯一标识的键名，绑定值为对象类型时必填
      , labelKey: {
        type: String,
        default: 'label'
      }  // 作为 label 唯一标识的键名，绑定值为对象类型时必填
      ,headLabelKey: {
        type: Boolean
        , default: false
      }    // 头部值是否取反
      , isTitle: {  // 是否显示option的title
        type: Boolean
        , default: false
      },
      placeholder: {
        type: String,
        default: '请选择'
      }
    }
    , watch: {
      value(newValue) {
        this.setCurrentValue(newValue);
      },
      currentOption () {
       this.setCurrentValue(this.value);
     }
    }
    , data() {
      return {
        isShow: false,
        currentValue: this.value ? this.value : '0',
        label: '',
        searchText: '',
        idx: -1
      }
    }
    , created() {
      // 初始化选中
      this.setCurrentValue(this.value, true)
    }
    , mounted() {
      // var self=this;
    }
    , methods: {
      hide() {
        this.isShow = false;
      },
      toggleSelectOption(event) {
        document.body.removeEventListener('click', this.hide);
        if (this.disabled) {
          this.isShow = false;
        } else {
          this.isShow = !this.isShow;
        }
        if (this.isShow) {
          setTimeout(() => {
            document.body.addEventListener('click', this.hide);
          })
        }
        this.$emit('click', event);
      },
      selectOption(item) {
        let value = item[this.valueKey];
        this.isShow = false;
        this.setCurrentValue(value);
      },
      setCurrentValue(selectValue, first) {
        // 设置选中值
        let self = this,
          {currentValue, currentOption} = self;
        if (selectValue !== currentValue || first) {
          let { labelKey, valueKey } = self,
            label = null,
            value = null,
            item = null,
            index = currentOption.findIndex((item) => {
              return item[valueKey] == selectValue
            });
          if (index > -1) {
            item = currentOption[index];
            label = item[labelKey];
            value = item[valueKey];
          }
          self.currentValue = value;
          self.idx = index;
          self.label = label;
          this.$emit('input', value, label, item);
          this.$emit('change', value, label, item);
          this.$nextTick(() => {
            this.dispatch('FormItem', 'form.change', value);
          });
        }
      }
    },
    computed: {
      currentOption () {
        return this.options || [];
      }
    }
  }
</script>
<style lang='scss' scoped>
  $font-size: 12px;
  $background: #fcfcfc;
  $height: 28px;
  $border: 1px solid #bccad0;
  $color: #535353;

  .cd-select-wrapper {
    display: inline-block;
    color: $color;
    // margin-right:30px;
    font-size: $font-size;
    position: relative;
    background-color: #fcfcfc;
    text-align: left;
    cursor: default;

    .select-top {
      &.disabled {
        cursor: not-allowed;
      }
      line-height: $height;
      height: $height;
      position: relative;
      border: $border;
      padding: 0 20px 0 10px;
      overflow: hidden;

      .toDown-icon {
        position: absolute;
        top: 0px;
        right: 0px;
        width: 19px;
        height: $height;
        background: #a6babf;

        &:after {
          content: '';
          position: absolute;
          top: 0;
          bottom: 0;
          right: 6px;
          margin: auto 0;
          // width: 7px;
          height: 0;
          border-top: 6px solid #6c7a86;;
          border-left: 4px solid rgba(0, 0, 0, 0);
          border-right: 4px solid rgba(0, 0, 0, 0);
        }
      }

      .left-wrapper {
        input {
          height: $height;
          padding-left: 10px;
          box-sizing: border-box;
          padding-right: 20px;
          display: none;
          color: #aaa;
        }
      }
    }

    .select-list {
      position: absolute;
      top: $height;
      left: 0;
      right: 0;
      background-color: #fff;
      z-index: 1000;
      box-shadow: 0px 5px 5px #ddd;
      transition: all .2s ease-out;
      border: $border;
      max-height: 182px;
      overflow-y: auto;
      width: 100%;
      box-sizing: border-box;
      // opacity:0;
      //  transition: all 10s;
      // -moz-transition: all 10s;
      // -webkit-transition: all 10s;
      // -o-transition:all 10s;

      &.hide {
        margin-top: -10px;
        visibility: hidden;
        opacity: 0;
        display: none
      }
      .search {
        width: 100%;
        height: 26px;
        line-height: 26px;
        margin-bottom: 2px;
        input {
          box-sizing: border-box;
          width: 100%;
          height: 26px;
          font-size: 12px;
          padding-left: 10px;
          border-top: 1px solid #fff;
          border-left: 1px solid #fff;
          border-right: 1px solid #fff;
          border-bottom: 1px solid #bccad0;
        }
      }
      .cd-select-item {
        position: relative;
        // border-bottom: $border;
        cursor: pointer;

        &:hover {
          background: #eaeef2;
        }

        .option-wrapper {
          display: block;
          overflow: hidden;
          height: 26px;
          line-height: 26px;
          padding: 0 10px 0 10px;
          color: #535353;
        }
      }
    }

  }

  .slide-fade-enter-active {
    transition: all .4s ease;
  }

  .slide-fade-leave-active {
    transition: all 1s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }

  .slide-fade-enter, .slide-fade-leave-to
    /* .slide-fade-leave-active for below version 2.1.8 */
  {
    transform: translateY(5px);
    opacity: 0;
  }

</style>
<style>
</style>



// WEBPACK FOOTER //
// components/Select/Select.vue